/* eslint-disable camelcase */

const defaultParameters = (page_type) => {
  if (!page_type) return null;
  return {
    platform: "web-desktop",
    page_type,
  };
};

export default defaultParameters;
